export default {"src":"/_next/static/media/LoginImg1.52c82e59.svg","height":905,"width":904,"blurWidth":0,"blurHeight":0};